import { Component, HostListener, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { OidcAuthService } from 'baseflow-auth';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { WizardStepBaseComponent } from '../';
import { TWizardStepId } from '../../../interfaces';
import { AppSettingsService } from '../../../services';

@Component({
    selector: 'app-wizard-step-create-account',
    templateUrl: './wizard-step-create-account.component.html',
    styleUrls: ['../base/wizard-step-base.component.scss', 'wizard-step-create-account.component.scss'],
    providers: [{ provide: WizardStepBaseComponent, useExisting: WizardStepCreateAccountComponent }],
    imports: [FormsModule, TranslatePipe],
})
export class WizardStepCreateAccountComponent extends WizardStepBaseComponent {
    private readonly translate = inject(TranslateService);
    private readonly oidcAuthService = inject(OidcAuthService);

    public id: TWizardStepId = 'account';
    public termsUrl: string;

    public nextButtonLabel = 'signUp';

    public constructor() {
        const appSettings = inject(AppSettingsService);

        super();

        appSettings.get(tap((settings) => (this.termsUrl = settings.url.terms))).subscribe();
    }

    public onBeforeShow(): Observable<unknown> | void {
        if (this.oidcAuthService.isAuthenticated()) {
            this.oidcAuthService.logout();
        }
    }

    @HostListener('keyup.enter')
    public onSubmit(): void {
        this.wizardService.stepSubmit.emit();
    }

    public checkPasswordsMatch(): void {
        if (!this.formControl) return;

        const password = this.formControl.get('password');
        const confirm = this.formControl.get('passwordConfirm');

        confirm.setErrors(confirm.value === password.value ? null : { mismatch: true });
    }

    protected submitWizardStep(): Observable<boolean> {
        const data = this.form;

        return this.oidcAuthService
            .registerUser({
                username: data.emailAddress,
                password: data.password,
                fullname: data.username,
                language: this.translate.currentLang,
                emailAddress: data.emailAddress,
            })
            .pipe(
                catchError((response) => {
                    if (response?.error?.errorCode === 'UsernameTaken')
                        this.formControl?.get('emailAddress')?.setErrors({ usernameTaken: true });

                    return of(false) as Observable<false>;
                }),
                map(Boolean)
            );
    }

    protected redirectToLogin(): boolean {
        this.oidcAuthService.login();
        return false;
    }
}
